import moment from 'moment-timezone';
import { MEDIA_PREFIX } from './services/constants';
import NProgress from 'nprogress';

NProgress.configure({ trickleSpeed: 150 });

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

function cmToInches(value, onlyInches = false) {
  var inches = value / 2.54;
  var feet = 0;

  if (onlyInches === false) {
    while (inches >= 12) {
      inches -= 12;
      feet += 1;
    }
  }

  // rounds to nearest 0.5 number

  return (onlyInches ? '' : feet + '" ') + (Math.round(inches * 2) / 2).toFixed(1) + "'";
}

function intlFormat(num: number) {
  return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
}

function sliceIntoChunks(arr, chunkSize) {
  const res: any = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}

function instagramRound(num: number) {
  if (num >= 1000000) return intlFormat(num / 1000000) + 'M';
  if (num >= 1000) return intlFormat(num / 1000) + 'k';
  return intlFormat(num);
}

function formatDecimalNumber(n: any): string {
  return n % 1 != 0 ? n.toString().replace('.5', '½') : n.toString();
}

function formatBigNumber(e: any): string {
  const number = parseInt(e, 10);

  if (number > 10 ** 6) {
    return `${Math.round(number / 10 ** 5) / 10}m`;
  } else if (number > 10 ** 3) {
    return `${Math.round(number / 100) / 10}k`;
  }

  return number.toString();
}

function redirectToDownloadUrl(url: string, name: string, progress: boolean = false) {
  progress && NProgress.start();

  const a = document.createElement('A') as HTMLAnchorElement;
  a.href = url;
  a.download = name;

  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);

  progress && NProgress.done();
}

function formatLikes(n: number): string {
  return n.toLocaleString();
}

function chunk<T>(arr: Array<T>, len: number): Array<Array<T>> {
  if (!arr) {
    return [];
  }
  const chunks: Array<Array<T>> = [];
  let i = 0;
  const n = arr.length;
  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }
  return chunks;
}

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function generateMonths(len: number): Array<MonthlyReportDate> {
  let year: number = new Date().getFullYear();
  let month: number = new Date().getMonth();
  let months: Array<MonthlyReportDate> = [];

  for (let i = 0; i < len; i++) {
    months.push({ month: month + 1, year });
    month--;
    if (month < 0) {
      month = 11;
      year--;
    }
  }
  return months;
}

function groupByKey<T>(data: Array<T>, key: string): { [key: string]: Array<T> } {
  return data.reduce((results, org) => {
    (results[org[key]] = results[org[key]] || []).push(org);
    return results;
  }, {});
}

function imageFix(url: string): string {
  return MEDIA_PREFIX + url;
  /*return (
    MEDIA_PREFIX +
    url
      .replace("https://s3.amazonaws.com/neoncoat-staging", "")
      .replace("https://media.neoncoat.com", "")
  );*/
}

/*
 * Creates an object composed of the picked object properties.
 * @param obj The source object
 * @param paths The property paths to pick
 */
function pick<T, K extends keyof T>(obj: T, paths: K[]): Pick<T, K> {
  return { ...paths.reduce((mem, key) => ({ ...mem, [key]: obj[key] }), {}) } as Pick<T, K>;
}

const timezone = (time, name) => {
  if (!time || !name) return '';
  const times = moment(time);
  const browserOffset = new Date().getTimezoneOffset();
  if (times.utcOffset() !== browserOffset) return ' ' + times.format('z');
  else return '';
};

const formatTime = (time: string | undefined, showAM: boolean = true, zone: string = '') => {
  const format = moment(time).minute() === 0 ? 'h' : 'h:mm';
  return moment.parseZone(time).format(format + (showAM ? 'a' : '')) + timezone(time, zone);
};

const formatCallTime = (time: string, zone: string = '') => {
  const hours = moment(time).minute() === 0 ? 'ha' : 'h:mma';
  return moment.parseZone(time).format('MMM. DD, ' + hours) + timezone(time, zone);
};

const formatTimePair = (
  first: string | undefined,
  second: string | undefined,
  timezone: string = ''
) => {
  const firstH = moment.parseZone(first).hour();
  const secondH = moment.parseZone(second).hour();
  const showAm = firstH > 12 !== secondH > 12;

  return formatTime(first, showAm, '') + ' - ' + formatTime(second, true, timezone);
};

export {
  chunk,
  pick,
  formatBigNumber,
  formatDecimalNumber,
  redirectToDownloadUrl,
  cmToInches,
  months,
  generateMonths,
  sliceIntoChunks,
  formatLikes,
  groupByKey,
  imageFix,
  formatTime,
  formatCallTime,
  formatTimePair,
  instagramRound,
};
